import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { constant } from 'app/modules/common/helpers/constant';
import { Observable } from 'rxjs';
import API from '../../common/services/api.config.json';
import { ApiService } from '../../common/services/api.service';

@Injectable({providedIn:'root'})
export class HeaderService {

  isLoading:boolean = false;
  public textsearch : any;
  
  constructor( private http: HttpClient, private apiService : ApiService) { }
  
  getSearchData(searchKey,empressaId)
  {   // var empressaId=1013
    let url: string = `${API.Search.getSearchData}`;
    url = url.replace('{searchKey}',searchKey.toString()).replace('{empressaId}',empressaId.toString());
    return this.apiService.get(url);
  }
}

